const UploadProgressBar = (props) => {
    return (
        <>
            {props.uploadProgress > 0 && <div style={{textAlign:'center'}}>{props.uploadProgress}%</div>}
        </>
    );
};

export default UploadProgressBar;
